<div class="image-wrapper">
  @if (!product.is_recommended && product.isFeatured) {
    <span class="tag font-5">Featured</span>
  }
  @if (!product.is_recommended && product.isPriorityItem) {
    <span class="tag font-5">Priority Item</span>
  }
  @if (product.is_recommended) {
    <span class="tag recommended font-5">Recommended</span>
  }
  <ngx-gallery
    [options]="galleryOptions"
    [images]="galleryImages"
    [ngClass]="{ mobile: modalView }"
  >
  </ngx-gallery>
  @if (isCancelled) {
    <div class="cancelled-extra-opacity"></div>
  }
  @if (isCancelled) {
    <div class="product-cancelled">Canceled</div>
  }
</div>
